import {getDateSlash} from "../../../utility/DateUtils";
import Loading from "../Loading";
import Random from "../Random";
import React, {useState} from "react";

const Body = ({items, indexResult}) => {
    const [num, setNum] = useState(null)

    const onMouseEnter = (value) => {
        setNum(value)
    }

    const onMouseLeave = () => {
        setNum(null)
    }

    return <table cellSpacing="0" cellPadding="0" className="bkqmiennam w-100">
        <tbody>
        <tr className="bg-number">
            <td onMouseEnter={() => onMouseEnter(0)} onMouseLeave={onMouseLeave} className="thu header f-bold"><a href="/"
                                                 title="Click xem tất cả KQXS Miền Trung ngày Thứ tư">{items.dayOfWeek}</a>
            </td>
            {
                items.header?.map((head, i) => {
                    return (
                        <td key={i} className={`thu header ${num === 0 ? "bg-result" : ""}`}><a href="/"
                                                              title="Click xem tất cả KQXS Miền Trung ngày Thứ tư">{head}</a>
                        </td>
                    )
                })
            }
        </tr>
        <tr>
            {
                items.subHeader?.map((sub, i) => {
                    return (
                        <td key={i}
                            onMouseEnter={() => i === 0 && onMouseEnter(1)} onMouseLeave={onMouseLeave}
                            className={`thu sub-header ${num === 1 ? "bg-result" : ""} ${i === 0 ? "date-head" : ""}`}>{i === 0 ? getDateSlash(sub) : sub}</td>
                    )
                })
            }
        </tr>
        {
            items && items.results?.map((result, index) => {
                const activeBg = (index + 2) === num
                return <tr key={index}
                           className={`post post-${index} ${index % 2 === 0 ? "" : "bg-number"}`}>
                    <td onMouseEnter={() => onMouseEnter(index + 2)} onMouseLeave={onMouseLeave} className="header"
                        width="85">{result.code}</td>
                    {
                        result.items.map((list, i) => {
                            return <td className={activeBg ? "bg-result" : ""} width="129" key={i}>
                                {list.map((e, k) => {
                                    if (e.includes("*")) {
                                        return <div key={k}><Loading sizeDigit={e.length}/></div>
                                    }
                                    if (e.includes("?")) {
                                        return (<div key={k}><Random sizeDigit={e.length}
                                                                     className="runLoto"/>
                                        </div>)
                                    }
                                    return <div key={k}
                                                className={`key-${k} pop-able-number-${indexResult}`}
                                                data-num={e}>{e}</div>
                                })}
                            </td>
                        })
                    }

                </tr>
            })
        }
        </tbody>
    </table>
}

export default Body;